<mat-sidenav-container (backdropClick)="close()">

  @if ((isScreenSmall | async)) {
    <mat-sidenav #sidenav class="docs-component-viewer-sidenav" align="start"
      [(opened)]="isSidenavOpened" [fixedInViewport]="(isScreenSmall | async)" (keydown.escape)="close()"
      (close)="close()">
      @if (isAuthenticated) {
        <app-responsive-navbar></app-responsive-navbar>
      }
    </mat-sidenav>
  }

  <div class="app-container">
    @if (isAuthenticated && hasAuthorisationControl && (!isMfaEnabled || (isMfaEnabled && isVerificationSuccessful))) {
      <app-toolbar (toggleSidenav)="toggleSidenav(sidenav)"></app-toolbar>
    }
    <div class="app-content__container" [ngClass]="{'has-padding' : (isAuthenticated && (!isMfaEnabled || (isMfaEnabled && isVerificationSuccessful))) ? true : false}">
      <router-outlet></router-outlet>
    </div>
    @if ((isAuthenticated && ishideScrollState) || (isAuthenticated && platform.TRIDENT)) {
      <div class="app-footer__container">
        <app-footer>
          <!-- OneTrust Cookies Settings button start -->
          <button id="ot-sdk-btn" class="ot-sdk-show-settings">Cookie Settings</button>
          <!-- OneTrust Cookies Settings button end -->
        </app-footer>
      </div>
    }
  </div>
</mat-sidenav-container>
